/* ===== industromart-ui-refresh.js ===== */
/* IndustroMart — presentation-only enhancements. No requests, cart writes, or inventory overrides. */
(() => {
  'use strict';
  if (window.__imUIRefreshLoaded) return;
  window.__imUIRefreshLoaded = true;
  const initialized = new WeakSet();
  const pairs = [
    [' Bosch ', ' بوش '], [' Freud ', ' فرويد '],
    [' RayTools ', ' راي تولز '], [' Senfeng ', ' سينفنج '], [' SENFENG ', ' سينفنج '],
    [' EMAS ', ' إيماس '], [' بوتشو ', ' بوشو '],
    [' Brushless ', ' بدون فحمات '], [' Heavy Duty ', ' خدمة شاقة '],
    [' Soft Start ', ' سوفت ستارت '], [' Long Life ', ' عمر تشغيل طويل '],
    [' Segmented ', ' مقسمة '], [' Turbo ', ' تربو '],
    [' Compact ', ' مدمج '], [' Mini ', ' صغير '], [' Hex ', ' كعب سداسي '],
    [' مقاس ', ' '], [' بقدرة ', ' '], [' قدرة ', ' '],
    [' سرعات يمين وشمال ', ' سرعات وعكس '], [' احترافي ', ' '], [' احترافية ', ' ']
  ];
  function displayTitle(raw) {
    let title = String(raw || '').trim();
    const match = title.match(/^(CAT|MT)\s+(\S+).*? - ([\s\S]+)$/u);
    if (match && /[\u0600-\u06ff]/u.test(match[3])) {
      title = match[3].trim();
      if (!title.includes(match[2])) title += ` — ${match[2]}`;
    }
    title = ` ${title} `;
    pairs.forEach(([from,to]) => { title = title.split(from).join(to); });
    return title.replace(/ {2,}/g,' ').trim();
  }
  const titleSelector = [
    'a.cart-items__title',
    '.resource-card[data-resource-type="product"] .resource-card__title',
    '.resource-card[data-resource-type="product"] .resource-card__link .visually-hidden',
    '[ref="productTitleLink"] .text-block > p',
    '.product-grid-view-zoom-out--details > h3',
    '#MainContent[data-template^="product"] h1'
  ].join(',');
  function normalizeTitles(root) {
    if (document.documentElement.lang !== 'ar') return;
    const nodes = [];
    if (root instanceof Element && root.matches(titleSelector)) nodes.push(root);
    if (root.querySelectorAll) nodes.push(...root.querySelectorAll(titleSelector));
    nodes.forEach(node => {
      // Do not replace HTML or controls. These verified selectors contain text-only product names.
      if (node.children.length) return;
      const old = node.textContent || '';
      const next = displayTitle(old);
      if (next && next !== old.trim()) node.textContent = next;
    });
  }
  // R4 ticker uses native CSS + a checkbox pause control; no animation lifecycle dependency.
  function setupMachines(grid) {
    if (initialized.has(grid)) return;
    const button = grid.querySelector('[data-industromart-machine-toggle]');
    const items = Array.from(grid.querySelectorAll('[data-industromart-machine-item]'));
    const panel = grid.querySelector('[data-industromart-machine-items]');
    if (!button || !panel || !items.length) return;
    initialized.add(grid);
    const ar = document.documentElement.lang === 'ar';
    grid.dataset.moreLabel = ar ? 'عرض المزيد' : 'Show more';
    grid.dataset.lessLabel = ar ? 'عرض أقل' : 'Show less';
    if (!panel.id) panel.id = `im-machines-${grid.closest('.shopify-section')?.id || 'home'}`;
    button.setAttribute('aria-controls',panel.id);
    const sync = () => {
      const expanded = button.getAttribute('aria-expanded') === 'true';
      items.forEach((item,index) => { item.hidden = !expanded && index >= 3; });
      button.hidden = items.length <= 3;
      button.textContent = expanded ? grid.dataset.lessLabel : grid.dataset.moreLabel;
      grid.dataset.imMachineReady = 'true';
    };
    // Preserve the existing custom element's click/expanded state; change the visible limit, not its prototype.
    button.addEventListener('click', () => queueMicrotask(sync));
    sync();
  }
  function enhance(root) {
    const find = selector => {
      const result = root.querySelectorAll ? Array.from(root.querySelectorAll(selector)) : [];
      if (root instanceof Element && root.matches(selector)) result.unshift(root);
      return result;
    };
    find('industromart-machine-grid').forEach(setupMachines);
    normalizeTitles(root);
    watchFloatingPanels(root);
  }
  let floatingFrame = 0;
  const floatingPanelSelector = 'sticky-add-to-cart,#shopify-pc__banner,#preview-bar-iframe,#ShopifyPreviewBar,#shopify-preview-bar,[data-shopify-preview-bar]';
  const watchedFloatingPanels = new WeakSet();
  const floatingResizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(scheduleFloating) : null;
  function watchFloatingPanels(root) {
    const panels = root.querySelectorAll ? Array.from(root.querySelectorAll(floatingPanelSelector)) : [];
    if (root instanceof Element && root.matches(floatingPanelSelector)) panels.push(root);
    panels.forEach(panel => {
      if (watchedFloatingPanels.has(panel)) return;
      watchedFloatingPanels.add(panel);
      if (floatingResizeObserver) floatingResizeObserver.observe(panel);
    });
  }
  function positionFloating() {
    floatingFrame = 0;
    const button = document.getElementById('IMWhatsApp');
    if (!button) return;
    const buttonRect = button.getBoundingClientRect();
    let offset = 0;
    document.querySelectorAll(floatingPanelSelector).forEach(panel => {
      const rect = panel.getBoundingClientRect();
      const style = getComputedStyle(panel);
      const visible = style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
      const overlapsX = rect.right > buttonRect.left && rect.left < buttonRect.right;
      if (visible && overlapsX && rect.top > innerHeight / 2 && rect.top < innerHeight && rect.bottom >= innerHeight - 2) {
        offset = Math.max(offset, Math.ceil(innerHeight - rect.top) + 8);
      }
    });
    const value = `${offset}px`;
    if (button.style.getPropertyValue('--im-floating-offset') !== value) button.style.setProperty('--im-floating-offset', value);
    document.body.dataset.imFloatingReady = 'true';
  }
  function scheduleFloating() { if (!floatingFrame) floatingFrame = requestAnimationFrame(positionFloating); }
  function start() {
    enhance(document);
    document.addEventListener('shopify:section:load',event => enhance(event.target));
    const pending = new Set();
    let frame = 0;
    const flush = () => { frame = 0; pending.forEach(node => { if (node.isConnected) enhance(node); }); pending.clear(); scheduleFloating(); };
    new MutationObserver(records => {
      records.forEach(record => {
        if (record.type === 'characterData') pending.add(record.target.parentElement);
        else record.addedNodes.forEach(node => { if (node instanceof Element) pending.add(node); else if (node.nodeType === Node.TEXT_NODE) pending.add(node.parentElement); });
      });
      pending.delete(null);
      if (pending.size && !frame) frame = requestAnimationFrame(flush);
    }).observe(document.body,{subtree:true,childList:true,characterData:true});
    document.addEventListener('scroll',scheduleFloating,{capture:true,passive:true});
    window.addEventListener('resize',scheduleFloating,{passive:true});
    window.addEventListener('pageshow',scheduleFloating,{passive:true});
    document.addEventListener('focusin',event => {
      if (event.target instanceof Element && event.target.matches('input:not(.im-ticker__pause),textarea,select')) document.body.classList.add('im-input-focused');
    });
    document.addEventListener('focusout',() => queueMicrotask(() => {
      document.body.classList.toggle('im-input-focused',!!document.activeElement?.matches('input:not(.im-ticker__pause),textarea,select'));
    }));
    scheduleFloating();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();

;

/* ===== industromart-ui-r7.js ===== */
/* IndustroMart UI R7 — 23 Sep 2026
   Uses Horizon's native menu/cart/search controls and canvas-based white-space normalization. */
(() => {
  'use strict';
  if (window.__imUIR7Loaded) return;
  window.__imUIR7Loaded = true;

  const CARD_IMAGE_SELECTOR = 'product-card .card-gallery .product-media img';
  const processed = new WeakMap();
  const pending = new WeakMap();
  const cachedCrop = new Map();
  const SAMPLE_MAX = 96;
  const OUTPUT = 420;

  const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

  function median(values) {
    if (!values.length) return 255;
    const a = values.slice().sort((x, y) => x - y);
    return a[Math.floor(a.length / 2)];
  }

  function fallbackImage(img) {
    const old = img.parentElement?.querySelector('.im-r7-media-canvas');
    old?.remove();
    img.dataset.imR7State = 'fallback';
  }

  function cornerStats(data, w, h) {
    const pts = [];
    const s = Math.max(3, Math.round(Math.min(w, h) * 0.08));
    const push = (x0, y0) => {
      const step = Math.max(1, Math.floor(s / 4));
      for (let y = y0; y < Math.min(h, y0 + s); y += step) {
        for (let x = x0; x < Math.min(w, x0 + s); x += step) {
          const i = (y * w + x) * 4;
          pts.push([data[i], data[i + 1], data[i + 2], data[i + 3]]);
        }
      }
    };
    push(0, 0);
    push(Math.max(0, w - s), 0);
    push(0, Math.max(0, h - s));
    push(Math.max(0, w - s), Math.max(0, h - s));

    const bg = [
      median(pts.map(p => p[0])),
      median(pts.map(p => p[1])),
      median(pts.map(p => p[2])),
      median(pts.map(p => p[3]))
    ];
    let variation = 0;
    pts.forEach(p => {
      const d = Math.hypot(p[0] - bg[0], p[1] - bg[1], p[2] - bg[2]);
      variation = Math.max(variation, d);
    });
    return { bg, variation };
  }

  async function getBitmap(src) {
    const response = await fetch(src, { mode: 'cors', credentials: 'omit', cache: 'force-cache' });
    if (!response.ok) throw new Error('image fetch failed');
    const blob = await response.blob();
    if ('createImageBitmap' in window) return await createImageBitmap(blob);

    return await new Promise((resolve, reject) => {
      const url = URL.createObjectURL(blob);
      const probe = new Image();
      probe.onload = () => {
        URL.revokeObjectURL(url);
        resolve(probe);
      };
      probe.onerror = () => {
        URL.revokeObjectURL(url);
        reject(new Error('image decode failed'));
      };
      probe.src = url;
    });
  }

  function detectCrop(bitmap) {
    const bw = bitmap.width || bitmap.naturalWidth;
    const bh = bitmap.height || bitmap.naturalHeight;
    if (!bw || !bh) return null;

    const scale = Math.min(1, SAMPLE_MAX / Math.max(bw, bh));
    const sw = Math.max(1, Math.round(bw * scale));
    const sh = Math.max(1, Math.round(bh * scale));
    const c = document.createElement('canvas');
    c.width = sw;
    c.height = sh;
    const ctx = c.getContext('2d', { willReadFrequently: true });
    if (!ctx) return null;
    ctx.drawImage(bitmap, 0, 0, sw, sh);

    const pixels = ctx.getImageData(0, 0, sw, sh).data;
    const { bg, variation } = cornerStats(pixels, sw, sh);

    /* Busy/lifestyle backgrounds should preserve their original composition. */
    if (variation > 62) return { x: 0, y: 0, w: bw, h: bh, confidence: 'full' };

    const bgBright = (bg[0] + bg[1] + bg[2]) / 3;
    const transparent = bg[3] < 48;
    let minX = sw, minY = sh, maxX = -1, maxY = -1, hits = 0;

    for (let y = 0; y < sh; y++) {
      for (let x = 0; x < sw; x++) {
        const i = (y * sw + x) * 4;
        const a = pixels[i + 3];
        if (a < 12) continue;

        let content = false;
        if (transparent) {
          content = a > 42;
        } else {
          const dist = Math.hypot(
            pixels[i] - bg[0],
            pixels[i + 1] - bg[1],
            pixels[i + 2] - bg[2]
          );
          const bright = (pixels[i] + pixels[i + 1] + pixels[i + 2]) / 3;
          content = dist > 28 || (bgBright > 238 && bright < 226);
        }
        if (!content) continue;
        hits++;
        minX = Math.min(minX, x);
        minY = Math.min(minY, y);
        maxX = Math.max(maxX, x);
        maxY = Math.max(maxY, y);
      }
    }

    if (hits < 16 || maxX < minX || maxY < minY) {
      return { x: 0, y: 0, w: bw, h: bh, confidence: 'full' };
    }

    let x = minX / scale;
    let y = minY / scale;
    let w = (maxX - minX + 1) / scale;
    let h = (maxY - minY + 1) / scale;

    const coverage = Math.max(w / bw, h / bh);
    if (coverage > 0.96) return { x: 0, y: 0, w: bw, h: bh, confidence: 'full' };

    const pad = Math.max(w, h) * 0.055;
    x = clamp(x - pad, 0, bw);
    y = clamp(y - pad, 0, bh);
    w = clamp(w + pad * 2, 1, bw - x);
    h = clamp(h + pad * 2, 1, bh - y);

    return { x, y, w, h, confidence: 'crop' };
  }

  function renderNormalized(img, bitmap, crop) {
    const host = img.closest('.product-media');
    if (!(host instanceof HTMLElement)) return fallbackImage(img);

    let canvas = host.querySelector('.im-r7-media-canvas');
    if (!(canvas instanceof HTMLCanvasElement)) {
      canvas = document.createElement('canvas');
      canvas.className = 'im-r7-media-canvas';
      canvas.setAttribute('aria-hidden', 'true');
      host.appendChild(canvas);
    }

    canvas.width = OUTPUT;
    canvas.height = OUTPUT;
    const ctx = canvas.getContext('2d');
    if (!ctx) return fallbackImage(img);
    ctx.clearRect(0, 0, OUTPUT, OUTPUT);

    const target = crop.confidence === 'crop' ? 0.88 : 0.84;
    const maxDim = OUTPUT * target;
    let dw, dh;
    if (crop.w >= crop.h) {
      dw = maxDim;
      dh = maxDim * (crop.h / crop.w);
    } else {
      dh = maxDim;
      dw = maxDim * (crop.w / crop.h);
    }
    const dx = (OUTPUT - dw) / 2;
    const dy = (OUTPUT - dh) / 2;

    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(bitmap, crop.x, crop.y, crop.w, crop.h, dx, dy, dw, dh);
    img.dataset.imR7State = 'cropped';
  }

  async function normalizeImage(img) {
    if (!(img instanceof HTMLImageElement)) return;
    const src = img.currentSrc || img.src;
    if (!src) return;
    if (processed.get(img) === src || pending.get(img) === src) return;
    pending.set(img, src);

    try {
      let crop = cachedCrop.get(src);
      const bitmap = await getBitmap(src);
      if (!crop) {
        crop = detectCrop(bitmap);
        cachedCrop.set(src, crop);
      }
      if ((img.currentSrc || img.src) !== src) {
        pending.delete(img);
        return normalizeImage(img);
      }
      renderNormalized(img, bitmap, crop);
      if (typeof bitmap.close === 'function') bitmap.close();
      processed.set(img, src);
      pending.delete(img);
    } catch (_) {
      pending.delete(img);
      processed.set(img, src);
      fallbackImage(img);
    }
  }

  let io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        normalizeImage(entry.target);
      });
    }, { rootMargin: '320px 0px' });
  }

  function queueImages(root = document) {
    const images = [];
    if (root instanceof Element && root.matches(CARD_IMAGE_SELECTOR)) images.push(root);
    if (root.querySelectorAll) images.push(...root.querySelectorAll(CARD_IMAGE_SELECTOR));
    images.forEach(img => {
      if (!(img instanceof HTMLImageElement)) return;
      const src = img.currentSrc || img.src;
      if (processed.get(img) === src || pending.get(img) === src) return;
      if (io) io.observe(img);
      else normalizeImage(img);
    });
  }

  function start() {
    queueImages(document);

    const mo = new MutationObserver(records => {
      records.forEach(record => {
        if (record.type === 'attributes' && record.target instanceof HTMLImageElement) {
          queueImages(record.target);
          return;
        }
        record.addedNodes.forEach(node => {
          if (node instanceof Element) queueImages(node);
        });
      });
    });
    const observeRoot = document.getElementById('MainContent') || document.body;
    mo.observe(observeRoot, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src', 'srcset']
    });

    document.addEventListener('shopify:section:load', event => {
      if (event.target instanceof Element) queueImages(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();

;

/* ===== industromart-heavy-checkout.js ===== */
(() => {
  'use strict';
  const THRESHOLD_GRAMS = 20000;
  const AR_MESSAGE = 'تنبيه بخصوص الشحن:\n\nلو إجمالي وزن طلبك أكتر من 20 كجم، تقدر تكمل الطلب عادي. بعد تسجيل الطلب، هيتواصل معاك أحد ممثلي خدمة العملاء لتأكيد تكلفة الشحن المناسبة حسب الوزن ومكان التوصيل قبل إرسال الشحنة.';
  const EN_MESSAGE = 'Shipping notice:\n\nIf your order weighs more than 20 kg, you can continue placing it normally. After the order is submitted, a customer service representative will contact you to confirm the appropriate shipping cost based on the weight and delivery location before the shipment is dispatched.';

  const continueCheckout = (button) => {
    button.dataset.industromartHeavyCheckoutBypass = '1';
    button.click();
  };

  document.addEventListener(
    'click',
    async (event) => {
      const button = event.target instanceof Element
        ? event.target.closest('button[name="checkout"], #checkout')
        : null;
      if (!button || button.disabled) return;

      if (button.dataset.industromartHeavyCheckoutBypass === '1') {
        delete button.dataset.industromartHeavyCheckoutBypass;
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
          method: 'GET',
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'application/json' }
        });

        if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
        const cart = await response.json();
        const totalWeight = Number(cart.total_weight) || 0;

        if (totalWeight > THRESHOLD_GRAMS) {
          const isArabic = (document.documentElement.lang || '').toLowerCase().startsWith('ar');
          const accepted = window.confirm(isArabic ? AR_MESSAGE : EN_MESSAGE);
          if (!accepted) return;
        }
      } catch (error) {
        console.warn('[IndustroMart] Heavy-checkout advisory unavailable; continuing checkout.', error);
      }

      continueCheckout(button);
    },
    true
  );
})();
;